/** Helpers for admin text – safe on server and client. */

const ENTITIES: Record<string, string> = {
  nbsp: ' ',
  amp: '&',
  lt: '<',
  gt: '>',
  quot: '"',
  '#39': "'",
};

/** Plain text of admin HTML (labels, alt texts, aria labels). */
export function stripTags(html?: string) {
  return html
    ? html
        .replace(/<[^>]*>/g, ' ')
        .replace(/&(nbsp|amp|lt|gt|quot|#39);/g, (_, name: string) => ENTITIES[name])
        .replace(/\s+/g, ' ')
        .trim()
    : '';
}

/** Admin links are typed by hand: trim them and add the leading slash to internal paths. */
export function cleanHref(href: string) {
  const value = stripTags(href);
  if (!value) return '';
  const encoded = value.replace(/ /g, '%20');
  if (/^(https?:|mailto:|tel:|#|\/)/i.test(encoded)) return encoded;
  return `/${encoded}`;
}

/** HTML datetime accepts at most millisecond precision; retain the API's date and offset. */
export function contentDateTime(value: string) {
  return value.replace(/(\.\d{3})\d+(?=Z$|[+-]\d{2}:?\d{2}$|$)/, '$1');
}

export function phoneHref(phone: string) {
  return `tel:${phone.replace(/[^\d+]/g, '')}`;
}

/** External http(s) link – opens in a new tab. */
export function isExternalHref(href: string) {
  return /^https?:\/\//i.test(href);
}

export type LinkData = { label: string; href: string };

/** Plain admin text (a page name) used where the component expects HTML. */
export function escapeHtml(text: string) {
  return text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}
